module.exports = __webpack_public_path__ + "img/439007-2.6500da8c.png";